
// 获取服务列表数据 -- v2
export function getServiceListV2(data) {
  return data.request({
    url: `${data.serveUrl}v2/service/showAll`,
    method: "get",
    params: data.params
  });
}
// 获取收藏应用 -- v2
export function getCollectServiceListV2(data) {
  return data.request({
    url: `${data.serveUrl}v2/service/collect/list`,
    method: "get",
    params: data.params
  });
}